import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { BilledTo, PortalInvoiceRow, portalInvoicePath } from './portalSpendCells'
import type { PortalSpendRow } from './portalSpend.types'

export function PortalTransactionsTable({
  rows,
  purchasedBy,
}: {
  rows: PortalSpendRow[]
  purchasedBy: boolean
}) {
  return (
    <Table aria-label="Invoices" className="[&_th]:whitespace-nowrap">
      <TableHeader>
        <TableRow>
          <TableHead>Invoice</TableHead>
          <TableHead>Category</TableHead>
          <TableHead>{purchasedBy ? 'Purchased by' : 'Billed to'}</TableHead>
          <TableHead className="text-right">Net</TableHead>
          <TableHead className="text-right">Total incl. VAT</TableHead>
          <TableHead>Status</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {rows.map((row) => (
          <PortalInvoiceRow key={row.invoice_id} row={row} href={portalInvoicePath(row)}>
            <TableCell className="capitalize">{row.category}</TableCell>
            <TableCell>
              {purchasedBy ? (row.purchased_by ?? '—') : <BilledTo row={row} />}
            </TableCell>
            <TableCell className="text-right tabular-nums">{row.net.formatted}</TableCell>
            <TableCell className="text-right font-medium tabular-nums">
              {row.gross_amount.formatted}
            </TableCell>
          </PortalInvoiceRow>
        ))}
      </TableBody>
    </Table>
  )
}
